import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-px-md"
}
const _hoisted_2 = {
  key: 1,
  class: "q-px-md q-pb-sm"
}
const _hoisted_3 = { class: "q-pt-md q-px-md" }
const _hoisted_4 = {
  key: 0,
  class: "row q-pt-md q-px-md"
}
const _hoisted_5 = { class: "col-6 q-pr-sm" }
const _hoisted_6 = { class: "col-6 q-pl-sm" }
const _hoisted_7 = {
  key: 1,
  class: "q-pt-md q-px-md"
}
const _hoisted_8 = { class: "q-pt-md q-px-md" }

import { ref, watch } from "vue";
  import { QSelect, QInput} from "quasar";

  import { AddressService } from "src/services";

  import { useStreet, useBuildingName, useFlatNo, useBuildingNo, useSubBuilding } from "src/functions";

  import { AddressLookupResultItem } from "src/types/address/index";
  import { Address } from "src/types/loan-application/index";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AddressLookup',
  props: {
    basic: {
      type: Boolean,
      default: false
    }
  },
  emits: ['addressSelected'],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const key = ref("");
  const selectedAddress = ref<AddressLookupResultItem | null>(null);
  const addressResults = ref<AddressLookupResultItem[]>([]);

  const manual = ref(false);
  const searchTerm = ref("");

  const address = ref({} as Address)

  async function postcodeLookup(val: string, update: Function) {
    if (selectedAddress.value) {
      update(() => {

      })
      return;
    }

    AddressService.addressLookup(val).then(addrs => {
      update(() => {
        addressResults.value = addrs;
      })
    }).catch(error => {
      update(() => {
        addressResults.value = [];
      })
    }).finally(() => {
      searchTerm.value = val;
    })
  }

  const selectRefs = ref <QSelect | null>(null)
  const postcodeRefs = ref<QInput | null>(null)
  const nameRefs = ref<QInput | null>(null)
  const numberRefs = ref<QInput | null>(null)
  const streetRefs = ref<QInput | null>(null)
  const townRefs = ref<QInput | null>(null)

  function resetAddress() {
    address.value.postcode = "";
    address.value.buildingName = "";
    address.value.buildingNumber = "";
    address.value.street = "";
    address.value.town = "";
    address.value.subBuilding = "";
    address.value.locality = "";
    setTimeout(() => {
      townRefs.value!.resetValidation();
      postcodeRefs.value!.resetValidation();
      nameRefs.value!.resetValidation()
      numberRefs.value!.resetValidation()
      streetRefs.value!.resetValidation()
    }, 100)
  }

  function isValid() {
    let valid = true;

    if (manual.value) {
      townRefs.value!.validate() ? null : valid = false;
      postcodeRefs.value!.validate() ? null : valid = false;
      if (!props.basic) {
        nameRefs.value!.validate() ? null : valid = false;
        numberRefs.value!.validate() ? null : valid = false;
        streetRefs.value!.validate() ? null : valid = false;
      }
    }
    else {
      selectRefs.value!.validate() ? null : valid = false;
    }

    return valid
  }

  

  __expose({ validate })
  function validate() {
    return isValid();
  }

  watch(selectedAddress, () => {
    if (!selectedAddress.value) {
      emit('addressSelected', {} as Address)
      return;
    }
    
    address.value.flatNumber = useFlatNo(selectedAddress.value.Property, selectedAddress.value.Street);
    address.value.buildingName = useBuildingName(selectedAddress.value.Property, selectedAddress.value.Organisation).trimStart();
    address.value.subBuilding = useSubBuilding(selectedAddress.value.Property, selectedAddress.value.Street, selectedAddress.value.Organisation);
    address.value.postcode = selectedAddress.value.Postcode;
    address.value.buildingNumber = useBuildingNo(selectedAddress.value.Street);
    address.value.street = useStreet(selectedAddress.value.Street);
    address.value.locality = selectedAddress.value.Locality;
    address.value.town = selectedAddress.value.Town;

    manual.value = true;
    emit('addressSelected', address.value)
  })

  watch(address.value, () => {
    if (manual.value) {
      emit('addressSelected', address.value)
    }
  })
  const emit = __emit

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!manual.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default"),
          _createVNode(_unref(QSelect), {
            outlined: "",
            dense: "",
            modelValue: selectedAddress.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedAddress).value = $event)),
            "use-input": selectedAddress.value ? false : true,
            "popup-content-class": "text-body2 limit-dd-height",
            clearable: "",
            onClear: resetAddress,
            ref_key: "selectRefs",
            ref: selectRefs,
            onFilter: postcodeLookup,
            "input-debounce": "500",
            options: addressResults.value,
            "option-label": "List",
            rules: [val => !!val || 'Required'],
            placeholder: selectedAddress.value ? undefined : 'Search by address or postcode…',
            "map-options": "",
            "hide-dropdown-icon": ""
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "mdi-magnify",
                color: "grey-6"
              })
            ]),
            option: _withCtx((scope) => [
              _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.opt.List), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1040)
            ]),
            "after-options": _withCtx(() => [
              (searchTerm.value !== '')
                ? (_openBlock(), _createBlock(_component_q_item, {
                    key: 0,
                    clickable: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (manual.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode(" Not found? - Manually enter details ")
                        ])),
                        _: 1,
                        __: [10]
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            "no-option": _withCtx(() => [
              (searchTerm.value !== '')
                ? (_openBlock(), _createBlock(_component_q_item, {
                    key: 0,
                    clickable: "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (manual.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode(" No results found - Manually enter details ")
                        ])),
                        _: 1,
                        __: [11]
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "use-input", "options", "rules", "placeholder"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_btn, {
            color: "primary",
            class: "brand-button",
            outline: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (manual.value=false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, [
                _cache[12] || (_cache[12] = _createTextVNode(" Search for an address ")),
                _createVNode(_component_q_icon, { name: "o_search" })
              ])
            ]),
            _: 1
          })
        ])),
    _createVNode(_component_q_expansion_item, {
      modelValue: manual.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((manual).value = $event)),
      class: "hide-header"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Postcode *", -1)),
          _createVNode(_unref(QInput), {
            outlined: "",
            modelValue: address.value.postcode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((address.value.postcode) = $event)),
            ref_key: "postcodeRefs",
            ref: postcodeRefs,
            rules: [val => !!val || 'Required'],
            dense: ""
          }, null, 8, ["modelValue", "rules"])
        ]),
        (!__props.basic)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Building Name", -1)),
                _createVNode(_unref(QInput), {
                  modelValue: address.value.buildingName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((address.value.buildingName) = $event)),
                  ref_key: "nameRefs",
                  ref: nameRefs,
                  "reactive-rules": "",
                  rules: [(val) => (val && val !== '' || (address.value.buildingNumber && address.value.buildingNumber !== '')) || 'Required'],
                  dense: "",
                  outlined: ""
                }, null, 8, ["modelValue", "rules"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Building Number", -1)),
                _createVNode(_unref(QInput), {
                  modelValue: address.value.buildingNumber,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((address.value.buildingNumber) = $event)),
                  ref_key: "numberRefs",
                  ref: numberRefs,
                  "reactive-rules": "",
                  rules: [(val) => (val && val !== '' || (address.value.buildingName && address.value.buildingName !== '')) || 'Required'],
                  dense: "",
                  outlined: ""
                }, null, 8, ["modelValue", "rules"])
              ])
            ]))
          : _createCommentVNode("", true),
        (!__props.basic)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Street *", -1)),
              _createVNode(_unref(QInput), {
                outlined: "",
                modelValue: address.value.street,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((address.value.street) = $event)),
                ref_key: "streetRefs",
                ref: streetRefs,
                rules: [val => !!val || 'Required'],
                dense: ""
              }, null, 8, ["modelValue", "rules"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Town *", -1)),
          _createVNode(_unref(QInput), {
            outlined: "",
            modelValue: address.value.town,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((address.value.town) = $event)),
            ref_key: "townRefs",
            ref: townRefs,
            rules: [val => !!val || 'Required'],
            dense: ""
          }, null, 8, ["modelValue", "rules"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})